export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "bd72d36.worker.js");
}
